export const FloatingOrbs = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
    <div className="absolute -top-10 left-[8%] h-56 w-56 rounded-full bg-lavender/25 blur-3xl animate-drift" />
    <div className="absolute top-[28%] right-[6%] h-72 w-72 rounded-full bg-ocean/25 blur-3xl animate-float-slow" />
    <div className="absolute bottom-[8%] left-[22%] h-64 w-64 rounded-full bg-green/25 blur-3xl animate-drift" style={{ animationDelay: "3s" }} />
    <div className="absolute top-[18%] left-[46%] h-7 w-7 rounded-full bg-white/80 blur-[2px] animate-float" />
    <div className="absolute bottom-[26%] right-[28%] h-4 w-4 rounded-full bg-lavender/60 blur-[1px] animate-float-slow" />
    <div className="absolute top-[62%] left-[14%] h-3.5 w-3.5 rounded-full bg-green/60 blur-[1px] animate-float" style={{ animationDelay: "1.5s" }} />
  </div>
);
